import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { HttpErrorResponse } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";

import { ClienteOutput } from "src/app/@shared/models/cliente.model";
import { ReplaySubject, Subject } from "rxjs";
import { ClienteService } from "src/app/services/cliente/cliente.service";
import { takeUntil } from "rxjs/operators";
import { ComplementoFaturaCteComponent } from "../complemento-fatura-cte.component";
import { ComplementoFaturaCteModel } from "../complemento-fatura-cte.model";
import { ComplementoFaturaCteService } from "src/app/services/complemento-fatura-cte/complemento-fatura-cte.service";
import { toInteger } from "lodash";

@Component({
  selector: "app-cadastro-complemento-fatura-cte",
  templateUrl: "./cadastro-complemento-fatura-cte.component.html",
  styleUrls: ["./cadastro-complemento-fatura-cte.component.scss"],
})
export class CadastroComplementoFaturaCte implements OnInit, AfterViewChecked {
  @Input() parent: ComplementoFaturaCteComponent;
  @Input() detalhes: ComplementoFaturaCteModel;
  @Input() featureId: string;
  @Input() perm;
  @Output("onSave") onSave: EventEmitter<any> = new EventEmitter();
  public value;

  public formCadastro: FormGroup = new FormGroup({
    optionUpload: new FormControl("1"),
    clienteId: new FormControl("", Validators.required),
    dataInicio: new FormControl(""),
    dataFim: new FormControl(""),
  });
  get optionUpload() {
    return this.formCadastro.get("optionUpload").value;
  }
  get clienteId() {
    return this.formCadastro.get("clienteId").value;
  }
  get dataInicio() {
    return this.formCadastro.get("dataInicio").value;
  }
  get dataFim() {
    return this.formCadastro.get("dataFim").value;
  }

  isLoading: boolean = false;
  isLoadingDownloadTemplate: boolean = false;

  private onDestroy = new Subject<void>();
  clientes: ClienteOutput[];
  public filteredClientes: ReplaySubject<ClienteOutput[]> = new ReplaySubject<
    ClienteOutput[]
  >(1);
  public clienteMultiFilter: FormControl = new FormControl();

  // UPLOAD DE EXCEL
  file: File;
  filename: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: ComplementoFaturaCteModel,
    private service: ComplementoFaturaCteService,
    private cdr: ChangeDetectorRef,
    public fb: FormBuilder,
    public snackBar: MatSnackBar,
    public clienteService: ClienteService
  ) {
    this.detalhes = data ?? this.detalhes;
  }

  ngOnInit() {
    this.listarClientes();
    this.formCadastro.get("clienteId").setValue(1769);
  }

  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  gerarArquivo(data: any, filename: string, type: string) {
    const arrBuffer = this.base64ToArrayBuffer(data);
    const blob = new Blob([arrBuffer], {
      type,
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  async onClick() {
    if((this.optionUpload == 2 || this.optionUpload == 3) && this.file == null) {
      return this.parent.openSnackBar(
        "É obrigatório enviar um arquivo para poder prosseguir.",
        "OK",
        3000,
        "alert-snackbar"
      );
    }
    if (this.optionUpload == 1 && (!this.dataInicio || !this.dataFim)) {
      return this.parent.openSnackBar(
        "Selecione uma data início e uma data fim!",
        "OK",
        3000,
        "alert-snackbar"
      );
    }
    if(this.optionUpload == '1') {
      this.downloadExcelCTEErros();
    } else {
      await this.changeFile(this.file);
    }
  }

  downloadExcelCTEErros() {
    const dataInicio = this.dataInicio ? this.dataInicio.toISOString().split('T')[0] : null;
    const dataFim = this.dataFim ? this.dataFim.toISOString().split('T')[0] : null;
    if (dataFim < dataInicio) {
      this.parent.openSnackBar('Data final não pode ser menor que data inicial.', 'OK', 3000);
      return;
    }
    this.isLoading = true;
    const obj = {
      dataInicial: this.dataInicio ? this.dataInicio.toISOString().split("T")[0] : null,
      dataFinal: this.dataFim ? this.dataFim.toISOString().split("T")[0] : null,
      clienteId: this.clienteId
    }
    this.service.exportarExcelCTEErros(obj).subscribe(
      (response: any) => {
        if(response) {
          this.parent.openSnackBar(
            `Sua solicitação esta em fila de processamento. Lote ${response.body.faturaLoteId}`,
            "OK",
            3000,
            "success-snackbar"
          );
          this.limparPesquisa();
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      },
      () => (this.isLoading = false)
  );
}


  loadFile(file) {
    if (
      file.target.files[0].type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
      file.target.files[0].type !== "application/vnd.ms-excel"
    ) {
      this.filename = "";
      this.file = null;
      return this.parent.openSnackBar(
        "Apenas arquivos .xls ou .xlsx são permitidos!",
        "OK",
        3000,
        "danger-snackbar"
      );
    } else {
      this.filename = file.target.files[0].name;
      this.file = file.target.files[0];
    }
  }

  async changeFile(file) {
    this.isLoading = true;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      const obj: any = {
        clienteId: this.clienteId,
        tipoFatura: toInteger(this.optionUpload),
        nomeArquivo: file.name,
        templateBase64: reader.result.toString().split(",")[1],
      };
      this.service.uploadExcel(obj).subscribe(
        async (response) => {
          if (response.body.teveSucesso === true) {
            this.parent.openSnackBar(
              `Sua solicitação esta em fila de processamento. Lote ${response.body.data.faturaLoteId}`,
              "OK",
              3000,
              "success-snackbar"
            );
            this.limparPesquisa();
          } else {
            this.parent.openSnackBar(
              response.body.mensagem,
              "OK",
              3000,
              "alert-snackbar"
            );
          }
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          let errorMSg = err.error.mensagem
            ? err.error.mensagem
            : "Ocorreu um erro ao fazer o upload! Tente novamente ou, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message;
          this.parent.openSnackBar(errorMSg, "OK", 10000, "warning-snackbar");
        },
        () => (this.isLoading = false)
      );
    };
  }

  limparPesquisa() {
    this.parent.gridData = null;
    this.parent.exibirGrid = false;
    this.parent.isLoading = false;
  }

  downloadExcelTemplateCTEAutorizado() {
    this.isLoadingDownloadTemplate = true;
    this.service.downloadTemplateCTEAutorizado().subscribe(
      (response: any) => {
        this.gerarArquivo(
          response.retorno.fileContents,
          response.retorno.fileDownloadName,
          response.retorno.contentType
        );
      },
      (err: HttpErrorResponse) => {
        console.error('error', err)},
      () => (this.isLoading = false)
    );
  }

  btnNextPrev = {
    prev: true,
    next: false,
    index: 0,
  };

  navig(n) {
    switch (n) {
      case "next":
        {
          this.btnNextPrev.index++;
          if (this.btnNextPrev.index >= 4) {
            this.btnNextPrev.prev = false;
            this.btnNextPrev.next = true;
          } else {
            this.btnNextPrev.prev = false;
          }
        }
        break;
      case "prev":
        {
          this.btnNextPrev.index--;
          if (this.btnNextPrev.index == 0) {
            this.btnNextPrev.prev = true;
            this.btnNextPrev.next = false;
          } else {
            this.btnNextPrev.next = false;
          }
        }
        break;
    }
  }

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  public async listarClientes() {
    return this.service
      .listarClientes()
      .toPromise()
      .then(
        (response: ClienteOutput[]) => {
          this.clientes = response.filter(x => x.id == 1769 && 1938);
          this.filteredClientes.next(this.clientes.slice());
          this.clienteMultiFilter.valueChanges
            .pipe(takeUntil(this.onDestroy))
            .subscribe(() => {
              this.filtroGeral(
                this.clientes,
                this.clienteMultiFilter,
                this.filteredClientes,
                "nome"
              );
            });
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.parent.openSnackBar(
            "Erro ao carregar clientes, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      );
  }

  private filtroGeral(
    filtro: any,
    multifilter: any,
    filtered: any,
    field: string
  ) {
    if (!filtro) {
      return;
    }
    let search = multifilter.value;
    if (!search) {
      filtered.next(filtro.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      filtro.filter(
        (response) => response[field].toLowerCase().indexOf(search) > -1
      )
    );
  }

  tooltipHelp(campo) {
    return `${campo}#${this.featureId}`;
  }
}
